import React from 'react';
import { useScreenInit } from './useScreenInit.js';
import { StickyBar } from './components/StickyBar';
import { Hero } from './components/sections/Hero';
import { CountdownSection } from './components/sections/CountdownSection';
import { Testimonials } from './components/sections/Testimonials';
import { PainPoints } from './components/sections/PainPoints';
import { Tomos } from './components/sections/Tomos';
import { Bonos } from './components/sections/Bonos';
import { EbookPremium } from './components/sections/EbookPremium';
import { ValueTable } from './components/sections/ValueTable';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { Comparison } from './components/sections/Comparison';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
import { TESTIMONIALS, MORE_TESTIMONIALS } from './data/content';
export function App() {
  useScreenInit();
  return <div className="w-full bg-carbon font-body text-soft" data-id="element-0">
      <StickyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <CountdownSection data-id="element-4" />
        <Testimonials heading="Lo que dicen los que ya lo tienen" items={TESTIMONIALS} data-id="element-5" />
        <PainPoints data-id="element-6" />
        <Tomos data-id="element-7" />
        <Bonos data-id="element-8" />
        <EbookPremium data-id="element-9" />
        <Testimonials heading="Más testimonios" items={MORE_TESTIMONIALS} data-id="element-10" />
        <ValueTable data-id="element-11" />
        <Guarantee data-id="element-12" />
        <Faq data-id="element-13" />
        <Comparison data-id="element-14" />
        <FinalCta data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}